module.exports = __webpack_public_path__ + "f649c961be1cc4de38aa6dee180b0b9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-diva-s.png
// module id = 1843
// module chunks = 0